<template>
  <v-row>
    <v-col
      cols="12"
      sm="6"
    >
      <div class="d-flex justify-center title font-weight-light">
        Configuração do WhatsApp
      </div>

      <v-scroll-y-transition mode="out-in">
        <div
          v-if="!showWhatsAppConfig"
          class="d-flex justify-center mt-10"
        >
          <span class="title font-weight-semibold overflow-auto">
            Essa plataforma não foi selecionada para uso.
          </span>
        </div>

        <bot-configuracao-whats-app
          v-else
          :chat-bot-id.sync="chatBotId"
          @reset-data="$emit('cancelar-configs')"
        />
      </v-scroll-y-transition>
    </v-col>

    <v-divider :vertical="$vuetify.breakpoint.name === 'xs' ? false : true"></v-divider>

    <v-col
      cols="12"
      sm="6"
    >
      <div class="d-flex justify-center title font-weight-light">
        Configuração do Messenger
      </div>

      <v-scroll-y-transition mode="out-in">
        <div
          v-if="!showMessengerConfig"
          class="d-flex justify-center mt-10"
        >
          <span class="title font-weight-semibold overflow-auto">
            Essa plataforma não foi selecionada para uso.
          </span>
        </div>

        <bot-configuracao-messenger
          v-else
          :chat-bot-id.sync="chatBotId"
          @reset-data="$emit('cancelar-configs')"
        />
      </v-scroll-y-transition>
    </v-col>
  </v-row>
</template>

<script>
import { computed } from '@vue/composition-api'
import BotConfiguracaoWhatsApp from './tab-plataforma/BotConfiguracaoWhatsApp.vue'
import BotConfiguracaoMessenger from './tab-plataforma/BotConfiguracaoMessenger.vue'

export default {
  components: { BotConfiguracaoWhatsApp, BotConfiguracaoMessenger },
  props: {
    chatBotId: {
      type: Number,
      required: true,
    },
    isMessengerSetted: {
      type: Boolean,
    },
    isWhatsAppSetted: {
      type: Boolean,
    },
  },

  setup(props) {
    const showWhatsAppConfig = computed(() => props.isWhatsAppSetted)
    const showMessengerConfig = computed(() => props.isMessengerSetted)

    return {
      showWhatsAppConfig,
      showMessengerConfig,

    }
  },
}
</script>
